import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './OutpostAI.css';

// Reuse public images that already exist in the repo for mock icons
// import outPostLogo from '../Public/Images/ff_outpost_logo.png';
// import eupraxiaLabsLogo from '../Public/Images/Eupraxia_X.jpg';
// import innovationArt from '../Public/Images/innovation-art.png';

function OutpostAI() {
    const [modal, setModal] = useState(null);

    const features = [
        {
            id: 'mock-1',
            // icon: outPostLogo,
            title: 'OutpostAI Core',
            description: 'Mocked feature description for OutpostAI core capabilities.',
            value: ['Mock benefit A', 'Mock benefit B', 'Mock benefit C']
        },
        {
            id: 'mock-2',
            // icon: eupraxiaLabsLogo,
            title: 'F3Iai Orchestration',
            description: 'Mocked orchestration features for demonstration purposes.',
            value: ['Mock benefit D', 'Mock benefit E']
        },
        {
            id: 'mock-3',
            // icon: innovationArt,
            title: 'Observability (Mock)',
            description: 'Placeholder observability and monitoring features.',
            value: ['Mock benefit F', 'Mock benefit G']
        }
    ];

    return (
        <div className="outpost-page">
            <section className="hero-section-outpost">
                <div className="hero-content">
                    <h1>OutpostAI (F3Iai)</h1>
                    <p>This is a mock product page for OutpostAI / F3Iai — content intentionally placeholder to match existing product pages.</p>
                </div>
            </section>

            <section className="features-section">
                <h2>Core (Mock) Features</h2>
                <div className="features-container">
                    {features.map((feature) => (
                        <div
                            key={feature.id}
                            className="feature"
                            onClick={() => setModal(feature)}
                        >
                            <img src={feature.icon} alt={feature.title} className="feature-icon" />
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="value-prop-section">
                <h2>Value Proposition (Mock)</h2>
                <ul>
                    <li>Mock: Scales to mission needs</li>
                    <li>Mock: Integrates with existing infrastructure</li>
                    <li>Mock: Designed for auditability</li>
                </ul>
            </section>

            <section className="outpost-cta-section">
                <p>Interested in OutpostAI? This is a mock call-to-action.</p>
                <a href="/contact" className="outpost-learn-more-button">Contact Us (Mock)</a>
            </section>

            {modal && (
                <div className="modal-overlay" onClick={() => setModal(null)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close" onClick={() => setModal(null)}>&times;</button>
                        <div className="modal-title">{modal.title}</div>
                        <div className="modal-description">{modal.description}</div>
                        <div className="modal-value">
                            <ul>
                                {modal.value.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default OutpostAI;
